import React, { FC, ReactElement } from 'react';
import { localeStore } from '~/mobx/localesStore';
import foodicsIntegrationStore from '~/view/screens/SettingsScreen/store/foodicsIntegrationStore';

interface IProps {
  syncInProgress: boolean;
  isFirstSync: boolean;
  syncAuto: boolean;
}

const FoodicsBottomSyncTip: FC<IProps> = (props: IProps): ReactElement | null => {
  if (props.syncInProgress) {
    return <span className="foodics-authorized-form__tip mt-2">{localeStore.t('t2_foodics_sync_inprogress')}</span>;
  }
  if (!props.isFirstSync && props.syncAuto) {
    return (
      <span className="foodics-authorized-form__dates mt-2">
        {localeStore.t('t2_foodics_next_sync')} {foodicsIntegrationStore.getNextSyncDate}
      </span>
    );
  }
  return null;
};

export default FoodicsBottomSyncTip;
